import React from 'react';
import PropTypes from 'prop-types';
import TextButton from 'Components/ComponentLibrary/Atoms/Inputs/TextButton';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Transition from 'Components/ComponentLibrary/Atoms/Transition';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import DisclaimerWithLink from './DisclaimerWithLink';

const WhatIfClientDisclaimer = ({ resource }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <VerticalStack spacing={2}>
      <StackItem>
        <Text
          align="left"
          color="mediumGray"
          text={resource.attr('disclaimerAbstract')}
          weight="book"
        />
      </StackItem>
      <StackItem>
        <Box align="center">
          <TextButton
            onClick={() => {
              setIsExpanded(!isExpanded);
            }}
            padding="none"
            size="xs"
          >
            <Text
              color="mediumGray"
              text={`${resource.attr('readMoreVerb')} ${
                isExpanded ? 'Less' : 'More'
              }`}
            />
          </TextButton>
        </Box>
      </StackItem>
      <Transition in={isExpanded} variant="collapse">
        <div>
          <StackItem>
            <DisclaimerWithLink text={resource.attr('disclaimerText')} />
          </StackItem>
        </div>
      </Transition>
    </VerticalStack>
  );
};

WhatIfClientDisclaimer.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default WhatIfClientDisclaimer;
